import React from 'react'
import MenuNav from '../../components/MenuNav'
import Edit from '../../components/Edit'

function EditBoard() {
  return (
    <>
      <MenuNav />
      <Edit />
    </>
  )
}

export default EditBoard
